export default __webpack_public_path__ + "static/media/favourited.f7649099.png";